import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=429582c5&"
import script from "./Swiper.vue?vue&type=script&lang=js&"
export * from "./Swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports